export const selectCurrentUser = (state) => { 
    return state.user
}; 

export const isAdminUser = (state) => { 
    return state.user?.admin ? true :false
}; 